import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import cx from "classnames";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles from "assets/jss/material-dashboard-react/views/modalStyle";
import SchemeCreate from "./SchemeCreate";
const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const LoanSchemeModal = ({ showModal, closeModal, record,selectedSchemeArary,selectedScheme,classesChild, loanApplicationId, editable, enabledMinMAxPercentageFieldsCharges, enableMinAndAnnualInterestRate }) => {
  const classes = useStyles();
  const handleClose = () => {
    closeModal();
  };
  return (
    <div className={classes.container}>
      <Dialog
        classes={{
          root: classes.center,
        }}
        maxWidth="lg"
        open={showModal}
        fullScreen={true}
        
        disableEscapeKeyDown
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogContent
          id="classic-modal-slide-description"
          className={cx(classes.modalBody, classes.loginMaxWidth)}
          justifyContent="center"
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <SchemeCreate
                closeModal={closeModal}
                selectedScheme={selectedScheme}
                selectedSchemeArary={selectedSchemeArary}
                classes={classesChild}
                loanApplicationId={loanApplicationId}
                 editable={editable}
                 enabledMinMAxPercentageFieldsCharges={enabledMinMAxPercentageFieldsCharges}
                 enableMinAndAnnualInterestRate={enableMinAndAnnualInterestRate}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
};
LoanSchemeModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  record: PropTypes.object,
};
export default LoanSchemeModal;